var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8462 3.84615C23.8462 1.72692 22.1192 0 20 0H3.84615C1.72692 0 0 1.72692 0 3.84615V16.1538C0 18.2731 1.72692 20 3.84615 20H20C22.1192 20 23.8462 18.2731 23.8462 16.1538V3.84615ZM13.8462 17.6923H3.84615C2.99615 17.6923 2.30769 17.0038 2.30769 16.1538V3.84615C2.30769 2.99615 2.99615 2.30769 3.84615 2.30769H13.8462V17.6923ZM21.5385 16.1538C21.5385 17.0038 20.85 17.6923 20 17.6923H16.1538V2.30769H20C20.85 2.30769 21.5385 2.99615 21.5385 3.84615V16.1538Z",
    strokeWidth: 0,
    fill: "#38393C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53764 6.53809L9.7485 9.42786C10.088 9.73343 10.088 10.2658 9.74849 10.5714L6.53764 13.4612",
    stroke: "#38393C",
    strokeWidth: 1.53846,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseRight);
export default __webpack_public_path__ + "static/media/collapse-right.46c093be00c77be7abbc9b80843a8f13.svg";
export { ForwardRef as ReactComponent };